import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=4f7f9682&scoped=true&"
import script from "./loaderComponent.vue?vue&type=script&lang=js&"
export * from "./loaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f9682",
  null
  
)

export default component.exports